import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { mockupRows } from './mocks';

export const AffordabilitySpotTable = () => {
  return (
    <div className={'mb-4'}>
      <TableContainer component={Paper}>
        <Table aria-label='customized table'>
          <TableHead>
            <TableRow>
              <TableCell align='right'></TableCell>
              <TableCell align='right'>Spot</TableCell>
              <TableCell align='right'>Revert date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mockupRows.map(row => (
              <TableRow key={row.name}>
                <TableCell component='th' scope='row'>
                  {row.name}
                </TableCell>
                <TableCell align='right'>{row.spot}</TableCell>
                <TableCell align='right'>{row.revertDate}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
